<template>
  <div class="success">
    <div class="successhtml">
      <div class="successhead">
        <div class="successheadtext">
          <p
            style="
              font-size: 18px;
              color: #275479;
              font-weight: bold;
              line-height: 30px;
            "
          >
            成功案例
          </p>
        </div>
      </div>
      <div class="successbody">
        <div class="successbodytext">
          <div class="successleft">
            <!-- <div
              v-bind:class="[form.bj ? class1 : class2]"
              style="margin-top: 60px"
              @click="showbj"
            >
              北京
            </div>
            <div v-bind:class="[form.bj ? class3 : class4]"></div>
            <div v-bind:class="[form.sh ? class1 : class2]" @click="showsh">
              上海
            </div>
            <div v-bind:class="[form.sh ? class3 : class4]"></div>
            <div v-bind:class="[form.gd ? class1 : class2]" @click="showgd">
              广东
            </div>
            <div v-bind:class="[form.gd ? class3 : class4]"></div>
            <div v-bind:class="[form.zj ? class1 : class2]" @click="showzj">
              浙江
            </div>
            <div v-bind:class="[form.zj ? class3 : class4]"></div>
            <div
              v-bind:class="[form.others ? class1 : class2]"
              @click="showqtdq"
            >
              其他地区
            </div>
            <div v-bind:class="[form.others ? class3 : class4]"></div> -->
            <div v-for="(item,index) in form" :key="index" :class="{martop:index=='bj'}" @click="choosearea(index)">
              <div v-bind:class="[item ? class1 : class2]">{{formn[index]}}</div>
              <div v-bind:class="[item ? class3 : class4]"></div>
            </div>
          </div>
          <div class="successright">
            <div class="righttext">
              <!-- <div v-for="(item,index) in form" :key="index"  :class="{disp:item==false}"> -->
                <div>
                <table>
                <tr>
          <td
            style="
              width: 620px;
              background: #e2e8f4;
              text-align: center;
              color: #454d60;
              padding-left: 0px;
            "
          >
            公司名称
          </td>
        </tr>
<tr v-for="(item1,index1) in formpage" :key="index1" @click="goto(item1.website)"><td :class="{active:item1.website!=''}">{{item1.companyname}}</td></tr>
                </table>
              </div>
              <div class="successcomfoot">
      <div v-for="(it,id) in yeshu" v-bind:key="id" @click="choosepage(id+1,area)" class="pagebutton" :class="{pageclickbutton:yeshu[id]==true}">{{id+1}}</div>
      共{{page}}页，{{tiao}}条</div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <wh7footer></wh7footer>
  </div>
</template>

<script>
import wh7footer from "./components/wh7/wh7footer.vue";
import axios from "axios";
export default {
 data() {
    return {
      class1: "clicktext",
      class2: "lefttext",
      form: {
        bj: true,
        sh: false,
        gd: false,
        zj: false,
        others: false,
      },
      formn: {
        bj: '北京',
        sh: '上海',
        gd: '广东',
        zj: '浙江',
        others: '其他地区',
      },
      class3: "showsanjiao",
      class4: "nosanjiao",
      tiao:'',
      page:'',
      yeshu:'',
      formtextall:{
        bj:['北京木叶山资产管理有限公司','北京资产管理有限公司','北京鸣谦资产管理有限公司','北京木叶山资产管理有限公司','北京资产管理有限公司','北京鸣谦资产管理有限公司','啊','北京资产管理有限公司','北京鸣谦资产管理有限公司','北京木叶山资产管理有限公司','北京资产管理有限公司','北京鸣谦资产管理有限公司'],
        sh:['上海睦沣投资管理有限公司'],
        gd:['深圳前海固禾资产管理有限公司'],
        zj:['杭州大元资本管理有限公司'],
        others:['青岛青石资产管理有限公司']
      },
      formtext:{
        bj:[],
        sh:[],
        gd:[],
        zj:[],
        others:[]
      },
      formpage:'',
      youxi:'',
      area:'bj',
    };
  },
  components: { wh7footer },

  methods: {
    choosearea(idx){
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
     
      this.yeshu=[]
      this.area=idx
      
      this.form[idx] = true;

      this.tiao=this.formtextall[idx].length
      this.page=Math.ceil( this.formtextall[idx].length/11)
     
      for(var it=0;it<this.page;it++){
        this.$set(this.yeshu,it,false)
      }
      
      this.choosepage(1,idx)
    },
    choosepage(p,idx){
      this.formtext={
        bj:[],
        sh:[],
        gd:[],
        zj:[],
        others:[]
      }
      for(var it=0;it<this.page;it++){
        this.$set(this.yeshu,it,false)
      }
      this.yeshu[p-1]=true
      
      if(this.formtextall[idx].length<p*11){
        for(var x=(p-1)*11;x<this.formtextall[idx].length;x++){
          
          this.$set(this.formtext[idx],x-(p-1)*11,this.formtextall[idx][x])
        }
      }
      else{
        
        for(var y=(p-1)*11;y<p*11;y++){
          this.$set(this.formtext[idx],y-(p-1)*11,this.formtextall[idx][y])
        }
        
      }
        
      this.formpage = this.formtext[idx]
      
    },
  goto(newpage){
    if(newpage!=''){
window.open(newpage, "_blank");
    }
    
  } ,

  },
  mounted(){
  
  

  axios.post("https://wh-api.wenhua.com.cn/api/WH7Success/GetWH7Success").then((res)=>{
  this.formtextall=res.data 
  this.choosearea('bj')
  }).catch((err)=>{console.log(err);})
  

  }
}
</script>

<style scoped>
td.active{
  cursor: pointer;
}
td.active:hover{
  color: blue;
}
.successcomfoot {
  width: 620px;
  margin-left: 0px;
  height: 40px;
  margin-top: 20px;
  text-align: right;
}
.pagebutton {
  display: inline-block;
  height: 25px;
  width: 25px;
  margin-right: 15px;
  border: 1px solid #dfdfdf;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  color: #adadad;
  user-select: none;
}
.pageclickbutton {
  display: inline-block;
  height: 25px;
  width: 25px;
  margin-right: 15px;
  border: 1px solid #dfdfdf;
  color: white;
  text-align: center;
  line-height: 25px;
  background: #22427d;
  cursor: pointer;
  user-select: none;
}
.martop{
  margin-top: 60px;
}
.disp{
  display: none;
}
.successhtml {
  margin-top: 20px;
  background: url("../../assets/images/cgal-bg.cca959fa.jpg") no-repeat center;
  background-size: 100% 100%;
  height: 819px;
  min-width: 1400px;
  width: 100%;
}
.successhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.successheadtext {
  position: absolute;
  top: 100px;
}
.successbody {
  width: 1200px;
  margin: 0 auto;
  height: 635px;
}
.successbodytext {
  width: 1010px;
  margin: 0 auto;
  height: 635px;
}
.successleft {
  float: left;
  width: 250px;
  background: url("../../assets/images/chenggonganli-left.png") no-repeat right;
  background-size: auto 100%;
  height: 635px;
}
.successright {
  float: left;
  width: 760px;
  background: url("../../assets/images/cgal-q.png") no-repeat left;
  background-size: 100% 100%;
  height: 635px;
  margin-left: -1px;
}
.lefttext {
  font-size: 16px;
  line-height: 40px;
  margin-top: 15px;
  letter-spacing: 1px;
  color: #76613a;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}
.clicktext {
  font-size: 16px;
  line-height: 40px;
  margin-top: 15px;
  letter-spacing: 1px;
  color: #76613a;
  text-align: center;
  font-weight: bold;
  width: 250px;
  background: white;
  cursor: pointer;
}
.showsanjiao {
  width: 250px;
  height: 10px;
  background: url("../../assets/images/cgal.png") no-repeat left;
}
.nosanjiao {
  width: 250px;
  height: 10px;
}
.righttext {
  margin-top: 60px;
}
td {
  height: 35px;
  border: 1px solid #cdcdcd;
  line-height: 35px;
  vertical-align: middle;
  font-size: 14px;
  padding-left: 40px;
  letter-spacing: 1px;
}
</style>